export const ONE_MINUTE_MS = 60000;
export const ONE_HOUR_MS = 3600000;
export const UI_TICK_INTERVAL_MS = 30000;
